(() => {
  const KEY = 'etMuseumAccessGranted_v320';
  const hasAccess = () => { try { return sessionStorage.getItem(KEY) === 'true'; } catch (_) { return false; } };
  const apply = () => {
    const active = hasAccess();
    document.body.classList.toggle('et-museum-access-granted', active);
    if (!active) return;
    document.querySelectorAll('.et-guided-menu-item').forEach(item => {
      item.classList.remove('et-menu-locked');
      item.setAttribute('aria-disabled','false');
      const control = item.querySelector('a, summary');
      if (control) control.removeAttribute('tabindex');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('pageshow', apply);
  document.addEventListener('shopify:section:load', apply);
})();
